import React from "react";
import whiteLogo from "../../images/whiteLogo.png";

const HomepageNav = () => {
  return (
    <div className="nav">
      <img src={whiteLogo} alt="" />
    </div>
  );
};

export default HomepageNav;
